import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React__default, { forwardRef } from 'react';
import styled, { useTheme } from 'styled-components';
import { typography, space, layout, positioning, display } from '../../../node_modules/@xstyled/system/dist/xstyled-system.es.js';
import { shouldForwardProp } from '../../should-forward-prop.js';
import { flexboxes } from '../../system.js';

var StyledList = /*#__PURE__*/styled("ul").withConfig({
  shouldForwardProp: function (prop, defaultValidtorFn) {
    return shouldForwardProp(prop) && defaultValidtorFn(prop);
  },
  displayName: "List__StyledList",
  componentId: "sc-tk2kor-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style-position: inside;\n  list-style-type: ", ";\n  padding: 0;\n  margin: 0;\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  list-style-position: inside;\n  list-style-type: ", ";\n  padding: 0;\n  margin: 0;\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (_a) {
  var _b = _a.listStyleType,
    listStyleType = _b === void 0 ? "disc" : _b;
  return listStyleType;
}, flexboxes, typography, space, layout, positioning, display);
var List = forwardRef(function (_a, ref) {
  var children = _a.children,
    _b = _a.fontFamily,
    fontFamily = _b === void 0 ? "normal" : _b,
    space = _a.space,
    rest = __rest(_a, ["children", "fontFamily", "space"]);
  var spaces = useTheme().spaces;
  return React__default.createElement(StyledList, __assign({
    ref: ref,
    fontFamily: fontFamily
  }, rest), React__default.Children.map(children, function (child, i) {
    return i !== React__default.Children.count(children) - 1 && child ? React__default.cloneElement(child, {
      marginBottom: spaces[space] || space
    }) : child;
  }));
});
List.displayName = "UnorderedList";
var OrderedList = forwardRef(function (_a, ref) {
  var children = _a.children,
    _b = _a.fontFamily,
    fontFamily = _b === void 0 ? "normal" : _b,
    _c = _a.listStyleType,
    listStyleType = _c === void 0 ? "decimal" : _c,
    rest = __rest(_a, ["children", "fontFamily", "listStyleType"]);
  return React__default.createElement(List, __assign({
    ref: ref,
    as: "ol",
    fontFamily: fontFamily,
    listStyleType: listStyleType
  }, rest), children);
});
OrderedList.displayName = "OrderedList";
var ListItem = /*#__PURE__*/styled("li").withConfig({
  shouldForwardProp: function (prop, defaultValidtorFn) {
    return shouldForwardProp(prop) && defaultValidtorFn(prop);
  },
  displayName: "List__ListItem",
  componentId: "sc-tk2kor-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), typography, flexboxes, layout, space);
var templateObject_1, templateObject_2;

export { List, ListItem, OrderedList, StyledList };
//# sourceMappingURL=List.js.map
